import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetOtherUsePerRegistersInputDto, OtherUsePerRegisterCreateDto, OtherUsePerRegisterDto, OtherUsePerRegisterExcelDownloadDto, OtherUsePerRegisterUpdateDto, OtherUseRegisterPairDto } from '../dtos/other-use-per-register/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class OtherUsePerRegisterService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: OtherUsePerRegisterCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUsePerRegisterDto>({
      method: 'POST',
      url: '/api/planning/otherUsePerRegisters',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/otherUsePerRegisters/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/otherUsePerRegisters',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  deleteByOtherUseAndRegisterPairs = (pairs: OtherUseRegisterPairDto[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'POST',
      url: '/api/planning/otherUsePerRegisters/delete-by-pairs',
      body: pairs,
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUsePerRegisterDto>({
      method: 'GET',
      url: `/api/planning/otherUsePerRegisters/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/otherUsePerRegisters/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetOtherUsePerRegistersInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OtherUsePerRegisterDto>>({
      method: 'GET',
      url: '/api/planning/otherUsePerRegisters',
      params: { otherUseId: input.otherUseId, otherUseName: input.otherUseName, otherUseRegisterArea: input.otherUseRegisterArea, otherUseRegisterAreaFrom: input.otherUseRegisterAreaFrom, otherUseRegisterAreaTo: input.otherUseRegisterAreaTo, gisOtherUseRegisterArea: input.gisOtherUseRegisterArea, gisOtherUseRegisterAreaFrom: input.gisOtherUseRegisterAreaFrom, gisOtherUseRegisterAreaTo: input.gisOtherUseRegisterAreaTo, registerAreaCorrection: input.registerAreaCorrection, registerAreaCorrectionFrom: input.registerAreaCorrectionFrom, registerAreaCorrectionTo: input.registerAreaCorrectionTo, otherUseAreaPercentage: input.otherUseAreaPercentage, otherUseAreaPercentageFrom: input.otherUseAreaPercentageFrom, otherUseAreaPercentageTo: input.otherUseAreaPercentageTo, isMainRegister: input.isMainRegister, isLastRegister: input.isLastRegister, registerId: input.registerId, registerName: input.registerName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: OtherUsePerRegisterExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/otherUsePerRegisters/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, otherUseId: input.otherUseId, otherUseName: input.otherUseName, otherUseRegisterArea: input.otherUseRegisterArea, otherUseRegisterAreaFrom: input.otherUseRegisterAreaFrom, otherUseRegisterAreaTo: input.otherUseRegisterAreaTo, gisOtherUseRegisterArea: input.gisOtherUseRegisterArea, gisOtherUseRegisterAreaFrom: input.gisOtherUseRegisterAreaFrom, gisOtherUseRegisterAreaTo: input.gisOtherUseRegisterAreaTo, registerAreaCorrection: input.registerAreaCorrection, registerAreaCorrectionFrom: input.registerAreaCorrectionFrom, registerAreaCorrectionTo: input.registerAreaCorrectionTo, otherUseAreaPercentage: input.otherUseAreaPercentage, otherUseAreaPercentageFrom: input.otherUseAreaPercentageFrom, otherUseAreaPercentageTo: input.otherUseAreaPercentageTo, isMainRegister: input.isMainRegister, isLastRegister: input.isLastRegister, registerId: input.registerId, registerName: input.registerName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUsePerRegisterDto[]>({
      method: 'GET',
      url: '/api/planning/otherUsePerRegisters/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: OtherUsePerRegisterUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUsePerRegisterDto>({
      method: 'PUT',
      url: `/api/planning/otherUsePerRegisters/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}